<template>
  <v-chip
    depressed
    :dark="isSelected"
    :color="isSelected ? theme.color : ''"
    @click="$emit('onClick')"
    @focus="$emit('focusOption', currentStock)"
    @blur="$emit('blurOption')"
  >
    <v-avatar v-if="stockImage">
      <img :src="stockImage" />
    </v-avatar>
    <slot></slot>
  </v-chip>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['value', 'stock', 'option', 'isSelected', 'level'],
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    }),
    stockImage() {
      var stock = this.stock.find((el) => {
        return this.level == 0 && el[1] && el[1].includes(this.option + '/')
      })
      if (stock) return stock[7]
      return null
    },
    hasStock() {
      if (!this.stock) {
        return false
      }

      var option = this.stock.find((el) => {
        return el[1] == this.option
      })
      if (option) {
        try {
          return parseInt(option[2]) > 0
        } catch (error) {
          return false
        }
      } else {
        return false
      }
    },
    currentStock() {
      var stock = this.stock.find((el) => {
        if (this.level == 0 && el[1] && el[1].includes(this.option + '/'))
          return true
        else if (this.level == 1 && el[1] && el[1].includes(this.value))
          return true
      })
      if (stock) return stock
      return null
    }
  }
}
</script>

<style lang="scss" scoped></style>
